export default {
  "name": "NCSwitch",
  "column": 1,
  "canAppend": false,
  "type": 1,
  "path": "LowCodeComponents.NCSwitch",
  "label": "开关",
  "schema": {
    "type": "object",
    "properties": {
      "moduleId": {
        "title": "区域编码",
        "description": "组件标识",
        "type": "string"
      },
      "className": {
        "title": "className",
        "description": "样式",
        "type": "string"
      },
      "fieldid": {
        "title": "自动化Id",
        "description": "自动化Id",
        "type": "string"
      },
      "showTip": {
        "title": "提示",
        "description": "提示",
        "type": "boolean"
      }
    },
    "required": [
      "moduleId"
    ]
  },
  "uiSchema": {},
  "slots": []
}